import { forwardRef } from 'react';
import MuiIconButton from '@mui/material/IconButton';
import type { IconButtonProps as MuiIconButtonProps } from '@mui/material/IconButton';

/** Alias direto do MUI: nenhum default de aparência do projeto diverge do componente. */
export type IconButtonProps = MuiIconButtonProps;

/** Botão de ícone do design system: fecha a lacuna documentada desde o `Componente_Button` para as classes circulares do legado (`btn-redondo`, `btn-close-modal`). */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton(props, ref) {
    return <MuiIconButton ref={ref} {...props} />;
  },
);
